'use client';

import { useEffect } from 'react';
import { Election } from '~/definitions/election';
import { getStore } from '~/mobx/AppStore';

type Props = {
    election?: Election;
    showJobPositionAndCity?: string;
};

const Client = (props: Readonly<Props>) => {
    const { election, showJobPositionAndCity = 'all' } = props;
    const { ballotStore } = getStore();

    const setElectionData = () => {
        if (election) {
            ballotStore.setSelectedElectionId(election.electionId);
            ballotStore.setElection(election);
        }
        ballotStore.setShowJobPositionAndCity(showJobPositionAndCity);
        ballotStore.setIsElectionInitialized(true);
    };

    useEffect(() => {
        setElectionData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [election]);

    return null;
};

export default Client;
